import { useState, useEffect } from 'react';

type BrowserNotificationPermission = NotificationPermission | "unsupported"

type ExtendedNotificationOptions = NotificationOptions & {renotify?: boolean}

// Custom Hook to manage browser notification permissions
export function useBrowserNotifications() {
    const [permission, setPermission] = useState<BrowserNotificationPermission>('default');

    useEffect(() => {
        if ('Notification' in window) {
            setPermission(Notification.permission)
        } else {
            setPermission("unsupported")
        }
    }, []);

    const requestPermission = async () => {
        if (!('Notification' in window)) return;

        const result = await Notification.requestPermission();
        setPermission(result);
        return result;
    };

    async function sendNotification(title: string, options: ExtendedNotificationOptions = {}) {
        if (!('Notification' in window) || Notification.permission == "denied") {
            return
        }

        // Default configuration for standard alerts
        const defaultOptions = {
            badge: '/badge.png',
            icon: '/logo192.png',
            ...options
        };

        if (Notification.permission == "default") {
            let permission = await requestPermission()
            if (permission !== "granted") return
        }
        return new Notification(title, defaultOptions);
    }

    return {permission, requestPermission, sendNotification};
}